import React from 'react';
import PropTypes from 'prop-types';
import { firstLetterWord } from '../utils/helpers';

const Avatar = ({ fullname, margin }) => (
  <div className="user-nav__user-photo" style={{ width: '32px', height: '32px', marginRight: margin }}>
    <svg viewBox="0 0 120 120" className="svg-circle">
      <rect x="0" y="0" width="120" height="120" rx="15" ry="15" />
      <text x="50%" y="50%" fontSize="50" textAnchor="middle" fill="#FFFFFF" style={{ dominantBaseline: 'central' }}>
        {firstLetterWord(fullname)}
      </text>
    </svg>
  </div>
);

Avatar.defaultProps = {
  margin: 0,
};
Avatar.propTypes = {
  fullname: PropTypes.string.isRequired,
  margin: PropTypes.number,
};
export default Avatar;
